<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="top_tance"></div>
    <div class="paddingContent">
      <div class="btn addBtn fr" @click="$router.push('/addDiary')">
        新增日記
      </div>
      <div class="tableWrap">
        <el-table :data="diaryList" stripe style="width:100%;" height="700px">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column prop="id" width="180" label="ID"> </el-table-column>
          <el-table-column prop="title" style="min-width:260px" label="標題">
            <template slot-scope="scope">
                <!-- :disabled="scope.row.title.length > 500" -->
              <el-tooltip
                :content="scope.row.title"
                placement="top"
                effect="light"
              >
                <div class="ellipsis-text">{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="180" label="主圖">
            <template slot-scope="scope">
              <div class="mainImgWrap normal_font">
                <img
                  class="mainImg"
                  :src="scope.row.primaryPictureUrl"
                  alt=""
                />
                <p
                  v-show="
                    scope.row.primaryPictureUrl !== '' &&
                      scope.row.primaryPictureUrl !== null
                  "
                  @click="previewImg(scope.row.primaryPictureUrl)"
                >
                  預覽
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="diaryType" width="80" label="類型">
          </el-table-column>
          <el-table-column prop="publishDate" width="180" label="發佈時間">
          </el-table-column>
          <el-table-column prop="commentNum" width="100" label="評論">
          </el-table-column>
          <el-table-column prop="likeNum" width="100" label="點讚數/投票數">
          </el-table-column>
          <el-table-column prop="status" width="100" label="發佈狀態">
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="250">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.roofPlacement == 0"
                @click="toTop(scope.row.id, 1)"
              >
                置頂
              </el-button>
              <el-button v-else type="text" @click="toTop(scope.row.id, 0)"
                >取消置頂</el-button
              >
              <el-button type="text" @click="viewComments(scope.row.id)"
                >查看評論</el-button
              >
              <el-button
                type="text"
                @click="$router.push('/editDiary?id=' + scope.row.id)"
                >編輯
              </el-button>
              <el-button type="text" @click="delDiary(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div v-if="imgProp" class="propWrap">
      <div class="prop-content mobile_show">
        <i class="iconfont icon-close fr hand" @click="closeProp"></i>
        <p class="prop-title normal_font">查看圖片預覽</p>
        <img class="previewImg" :src="previewImgUrl" alt="" />
        <div class="bottomBtn">
          <!--<div class="btn">取消</div>-->
          <div class="btn hand new_btn" @click="closeProp">確認</div>
        </div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";

export default {
  data() {
    return {
      showTips: false,
      imgProp: false,
      previewImgUrl: "",
      navBlock: "新聞",
      navtitle: "Wayne",
      diaryList: [],
      blockType: "",
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false
    };
  },
  created() {
    this.permissionsTips();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    permissionsTips() {
      let _this = this;
      let roleType = localStorage.getItem("roleType");
      console.log(roleType);
      if (roleType.indexOf("ROLE_SUPER_ADMIN") > -1) {
        console.log("init");

        _this.initList();
      }
    },
    //初始列表
    initList() {
      let _this = this;
      let param = {
        type: 1,
        page: _this.currentPage,
        size: 10
      };
      _this
        .$post("/request/diary/getDiaryList", param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.data.list == "") {
            _this.showTips = true;
          } else {
            res.data.list.forEach(v => {
              v.publishDate = _this.$getTime(v.publishDate);
              switch (v.diaryType) {
                case 1:
                  v.diaryType = "文字";
                  break;
                case 2:
                  v.diaryType = "圖文";
                  break;
                case 3:
                  v.diaryType = "視頻";
                  break;
                case null:
                  v.diaryType = "JJ日記";
                  break;
              }
              if (v.status === 1) {
                v.status = "已發佈";
              } else if (v.status === 2) {
                v.status = "待發佈";
              }
            });

            _this.diaryList = res.data.list;
            _this.showTips = false;
          }
          _this.total = res.data.allRow;
        });
    },

    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initList();
    },
    closeProp() {
      this.imgProp = false;
    },
    previewImg(url) {
      this.imgProp = true;
      this.previewImgUrl = url;
    },
    //查看评论
    viewComments(id) {
      this.$router.push(`/viewComment?id=${id}&fromPage=diary`);
    },
    // 删除日记
    delDiary(id) {
      let _this = this;
      this.$confirm("是否刪除該新聞?", "提示信息", {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        center: true,
        closeOnClickModal: false
      }).then(() => {
        // 确认删除的回调
        _this
          .$get(`/request/diary/deleteDiary/${id}`, _this.$GLOBAL.jsonConfig)
          .then(res => {
            _this.dialogVisible = true;
            if (res.code === "00000") {
              _this.$propMessage("刪除成功", "success", function() {
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.initList();
              });
            } else {
              _this.$propMessage(res.message, "error", function() {
                _this.dialogVisible = false;
              });
            }
          });
      });
    },
    toTop(id, flag) {
      let _this = this;
      let param = {
        articleType: 1,
        articleId: id,
        top: Number(flag)
      };
      _this
        .$put(`/request/article/articleTop`, param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          _this.dialogVisible = true;
          if (res.code === "00000") {
            if (flag == 0) {
              _this.$propMessage("Wayne取消置頂成功", "success", function() {
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.initList();
              });
            } else {
              _this.$propMessage("Wayne置頂成功", "success", function() {
                _this.dialogVisible = false;
                _this.currentPage = 1;
                _this.initList();
              });
            }
          } else if (res.code === "80001") {
            this.$confirm(
              "同時只支持一篇JJ日記置頂，請取消置頂後再設置?",
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            ).then(() => {});
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .top_tance {
    padding-top: 0.8rem;

    @media (max-width: 768px) {
      padding-top: 22px;
    }

    @media (max-width: 420px) {
      padding-top: 62px;
    }
  }

  .paddingContent {
    //height: calc(100% - 88px);
    //padding: 0 0.4rem;
    //
    //@media (max-width: 768px) {
    //  height: calc(100% - 62px);
    //}

    padding-top: 0;

    .addBtn {
      margin: 0.2rem 0;
      cursor: pointer;

      @media (max-width: 420px) {
        margin-top: 0.3rem;
        margin-bottom: 10px;
      }
    }

    .btn {
      @media (max-width: 420px) {
        width: 1.3rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 12px;
      }
    }

    .tableWrap {
      width: 100%;
      overflow: auto;
      word-break: break-all;
      height: 7rem;
    }

    .previewImg {
      width: 7rem;
      display: block;
      padding: 0.2rem 0 0.3rem 0;
      margin: 0 auto;
    }
  }

  .bottomBtn {
    padding-bottom: 0.4rem;
  }

  .icon-close {
    margin: 10px;
  }

  .hand {
    cursor: pointer;
  }

  .propWrap {
    .prop-content {
      height: 90%;
      overflow: auto;

      img {
        // width: 38%;
        width: 70%;
        // max-height:5rem;
        // max-height:76%;
        @media (max-width: 420px) {
          width: 50%;
        }
      }
    }
  }

  .mobile_show {
    @media (max-width: 420px) {
      top: 45%;
    }
  }

  .paging-block {
    margin: 0.2rem 0;

    @media (max-width: 420px) {
      margin: 0.3rem 0;
    }
  }

  .label_num {
    font-size: 14px;
    line-height: 32px;
  }

  .show_picture {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .icon_font {
    font-size: 60px;
  }

  .success_font {
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 40px;
    color: #606266;
  }

  .table_font {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }

  .prop-title {
    color: #303133;
    padding: 0.1rem;
  }

  .mainImgWrap {
    display: flex;
    justify-content: center;
    align-items: center;

    .mainImg {
      max-height: 0.6rem;
      max-width: 0.6rem;
      border-radius: 0.05rem;
    }

    p {
      min-width: 0.6rem;
      padding-left: 0.1rem;
      color: @mainColor;
      cursor: pointer;
      white-space: nowrap;
    }
  }
}
.ellipsis-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制为3行 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal; /* 使文本换行 */
}
</style>



// WEBPACK FOOTER //
// src/pages/news/JJdiary/JJdiary.vue